import { useState } from "react";

export const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState<string>("current");
  const isMobileView = screenSize === "mobile";

  return { screenSize, setScreenSize, isMobileView };
};
